import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";

import { translate as t } from "infrastructure/translate/localization";

import StepHeader from "../../components/StepHeader";
import Table from "../../../../../Table";
import EmptyDataForTableMessage from "../../components/EmptyDataForTableMessage";
import TableDataSpinner from "../../components/TableDataSpinner";
import StepFooter from "../../components/StepFooter";
import * as RemainingBalanceTable from "./config";

export default function RemainingBalance({
  employees,
  currentStep,
  content,
  data,
  isLoading,
  target,
}) {
  return (
    <Grid item container xs={12}>
      <StepHeader {...content} />
      {isLoading ? (
        <TableDataSpinner />
      ) : (
        <>
          {!data?.adjustments?.length > 0 ? (
            <Table
              columns={RemainingBalanceTable.getColumns()}
              data={RemainingBalanceTable.getData(data)}
            />
          ) : (
            <EmptyDataForTableMessage
              message={t("common-messages.empty-data-for-selected-employees", {
                dataName: t(
                  "employees-section.current-month-consumptions"
                ).toLowerCase(),
              })}
            />
          )}
        </>
      )}
      <StepFooter
        isLoading={isLoading}
        currentStep={currentStep}
        employees={employees}
        target={target}
        hasNoData={data?.adjustments?.length === 0}
      />
    </Grid>
  );
}

RemainingBalance.defaultProps = {
  employees: [],
  data: { adjustments: [] },
  adjustmentsPagination: undefined,
  isLoading: false,
  currentStep: 0,
  country: "ES",
};

RemainingBalance.propTypes = {
  employees: PropTypes.array,
  data: PropTypes.object,
  content: PropTypes.object.isRequired,
  adjustmentsPagination: PropTypes.object,
  isLoading: PropTypes.bool,
  currentStep: PropTypes.number,
  country: PropTypes.string,
};
